module.exports = __webpack_public_path__ + "4012af54323f8005614ce4ac93d306c5.pdf";